import React from 'react';

export function GrowIcon({
  width = 32,
  fillColor = 'white',
  ariaLabel = 'A flower icon',
}: {
  width?: number;
  fillColor?: string;
  ariaLabel?: string;
}) {
  return (
    <svg
      aria-label={ariaLabel}
      width={width}
      viewBox="0 0 32 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fillColor}
        d="M13.04 9.907a5.166 5.166 0 012.322-.752c.244-1.523-.188-3.478-1.326-5.284C12.156.881 9.646-.923 7.202.61c-2.445 1.533-1.909 4.579-.028 7.578 1.137 1.805 2.698 3.046 4.183 3.487a5.038 5.038 0 011.683-1.767zM18.52 18.612a5.165 5.165 0 01-2.321.752c-.245 1.523.188 3.479 1.325 5.284 1.88 2.99 4.39 4.794 6.835 3.262 2.444-1.533 1.908-4.579.028-7.568-1.138-1.805-2.698-3.046-4.184-3.488a5.091 5.091 0 01-1.682 1.758z"
      />
      <path
        fill={fillColor}
        d="M20.081 11.448c1.317-.564 2.652-1.73 3.639-3.337 1.852-3.008 2.369-6.054-.094-7.568-2.463-1.513-4.955.31-6.807 3.319-1.119 1.814-1.532 3.76-1.278 5.283a5.11 5.11 0 014.54 2.303zM11.48 17.07c-1.317.564-2.652 1.73-3.64 3.338-1.851 3.008-2.368 6.054.095 7.568 2.463 1.513 4.954-.31 6.806-3.319 1.12-1.814 1.533-3.76 1.279-5.283a5.13 5.13 0 01-4.54-2.304z"
      />
      <path
        fill={fillColor}
        d="M20.279 16.704c1.26.884 3.206 1.354 5.32 1.128 3.517-.376 6.234-1.833 5.933-4.71-.301-2.877-3.272-3.732-6.788-3.356-1.87.197-3.497.893-4.578 1.833.987 1.608.959 3.544.113 5.105zM11.282 11.815c-1.26-.883-3.206-1.354-5.321-1.128-3.516.376-6.233 1.833-5.932 4.71.3 2.877 3.271 3.732 6.787 3.356 1.871-.197 3.497-.893 4.57-1.833-.978-1.617-.95-3.544-.104-5.105zM15.362 9.155c-.8.066-1.598.292-2.322.752a5.2 5.2 0 00-1.683 1.768M16.198 19.364c.8-.066 1.599-.291 2.323-.752a5.2 5.2 0 001.682-1.767M20.081 11.448a5.109 5.109 0 00-4.54-2.303l4.54 2.303zM11.48 17.07a5.109 5.109 0 004.54 2.304l-4.54-2.304z"
      />
      <path
        fill={fillColor}
        d="M20.279 16.704a5.11 5.11 0 00-.113-5.105l.113 5.105zM11.282 11.815a5.11 5.11 0 00.113 5.105l-.113-5.105z"
      />
      <path
        d="M15.804 20.408L15.869 40M15.785 19.42a5.143 5.143 0 100-10.285 5.143 5.143 0 000 10.286z"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        stroke={fillColor}
      />
    </svg>
  );
}
